export const CLASS_NAMES = {
  header: 'text-20-24-em md:text-24-28-em mb-4',
  subheader: 'text-14-22 md:text-16-24 mb-6',
};
